import "../node_modules/select2/dist/js/select2";

$(() => {
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  $('select.multi-select').select2({
    placeholder: "",
    closeOnSelect: false,
  });

  $('.resource-search .form-group').each(() => {
    $(this).find('.select2-search > input').hide();
    $this.find('.select2-search').append(`<span>${$this.children("label").text()}</span>`);
  });

  const clearButton = debounce(() => {
    $('.facetwp-template').removeClass('is-loading');
    if ($('.facetwp-selections ul').children().length > 0) {
      $('.facetwp-reset-button').addClass('filtered');
    } else {
      $('.facetwp-reset-button').removeClass('filtered');
    }
  }, 10);
  clearButton();

  $(document).on('facetwp-loaded', () => {
    clearButton();
  });
  $(".facetwp-checkbox, .facetwp-reset-button").on('click', (e) => {
    $('.facetwp-template').addClass('is-loading');
  });

  $(".facetwp-reset-button").on('click', (e) => {
      $(".facet-checkbox-select-all").addClass("checked");
  });


  /* 2021-07-21 commented by Amith */
  /* same according function overwrite in plugins/berg/src/block/post-block/inc/views/layouts/partial/multi-select-filter-with-load-more.php  &  plugins/berg/src/block/post-block/inc/views/layouts/partial/multi-select-filter-with-pagination.php */
});
